/* jshint esversion: 6 */

const input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';
const $document = $(document);

$document.on('focus', input_selector, function () {
    $(this).siblings('label, .prefix').addClass('active');
});

$document.on('blur', input_selector, function () {
    const $inputElement = $(this);
    let selector = '.prefix';

    if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === undefined) {
        selector += ', label';
    }

    $inputElement.siblings(selector).removeClass('active');
});

// $document.ajaxComplete(() => {
//     setTimeout(() => {
//         $(input_selector).filter(function () {
//             return $(this).val();
//         }).siblings('label').addClass('active');
//     }, 200);
// });
